/* =======================================================================
   Knowledge Base — the badge a walkthrough leaves in the header.
   Azure item 416, phase 3.

   After a walkthrough the contrast returns to normal and this stays beside
   the page title: "Walkthrough complete · Replay", or "paused · Resume" if
   the reader left early. Replay starts over; Resume picks them up at the
   first thing still to do. The ✕ removes it. Rendered by header.js.
   ======================================================================= */
import { useEffect, useState } from 'react';
import { KB_CHANGE, SESSION, announce } from './kbSession';
import { wtBadgeState, wtBadgeSlug } from './KbWalkthrough';
import './kb.css';

export default function KbBadge(){
  const [state, setState] = useState(wtBadgeState);
  useEffect(() => {
    const sync = () => setState(wtBadgeState());
    window.addEventListener(KB_CHANGE, sync);
    return () => window.removeEventListener(KB_CHANGE, sync);
  }, []);
  if (!state) return null;

  const done = state === 'done';
  const go = () => window.dispatchEvent(new CustomEvent('makani-kb-walk-resume', {
    detail: { slug: wtBadgeSlug(), resume: state === 'paused' }
  }));
  const dismiss = () => { SESSION.setItem('makaniKbWtBadge', ''); announce(); };

  return (
    <span className="kb-wt-badge">
      <button className="kb-wt-badge-main" type="button" onClick={go}>
        {done
          ? <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M4 12.5l5.5 5.5L20 7"/></svg>
          : <svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M5 3l14 9-14 9z"/></svg>}
        {done ? 'Walkthrough complete · Replay' : 'Walkthrough paused · Resume'}
      </button>
      <button className="kb-wt-badge-x" type="button" title="Dismiss" onClick={dismiss}>
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6"><path d="M6 6l12 12M18 6L6 18"/></svg>
      </button>
    </span>
  );
}
